import { enableProdMode, importProvidersFrom, isDevMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideRouter } from '@angular/router';
import { appRoutes } from './app/app.routes';
import { applyPolyfills, defineCustomElements } from '@betha-plataforma/estrutura-componentes/loader';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { ServiceWorkerModule, provideServiceWorker } from '@angular/service-worker';
import { tokenInterceptor } from './app/core/interceptors/TokenInterceptor/token-interceptor.service'; 

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    provideHttpClient(withInterceptors([tokenInterceptor])), 
    provideRouter(appRoutes),
    provideAnimationsAsync(),
    importProvidersFrom(
      ServiceWorkerModule.register('./ngsw-worker.js', {
        enabled: environment.production,
        registrationStrategy: 'registerWhenStable:30000', // Updates every 30 minutes
      })
    ),
    provideServiceWorker('ngsw-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:30000',
    }),
  ],
}).catch((err) => console.error('Error bootstrapping the application:', err));

applyPolyfills()
  .then(() => defineCustomElements(window))
  .catch((err) => console.error('Error loading Betha Web Components:', err));